var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadColored(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.73883 2.05246C2.86699 2.05246 2.16006 2.75939 2.16006 3.63123V20.4718C2.16006 21.3436 2.86699 22.0506 3.73883 22.0506H16.369C17.2409 22.0506 17.9478 21.3436 17.9478 20.4718V8.80961C17.9478 8.34883 17.7464 7.91097 17.3964 7.61091L11.3552 2.43253C11.069 2.18726 10.7046 2.05246 10.3277 2.05246L3.73883 2.05246ZM1.1076 3.63123C1.1076 2.17808 2.28568 1 3.73883 1H10.3277C10.9559 1 11.5633 1.22466 12.0401 1.63345L18.0814 6.81183C18.6644 7.31171 19.0001 8.04156 19.0001 8.80961V20.4718C19.0001 21.9249 17.822 23.103 16.3688 23.103H3.73865C2.2855 23.103 1.10742 21.9249 1.10742 20.4718L1.1076 3.63123Z",
    fill: "#2775EB",
    stroke: "#2775EB",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5801 5.7366V2.05273H11.6325V5.7366C11.6325 6.60844 12.3395 7.31537 13.2113 7.31537H17.9476V8.36783H13.2113C11.7582 8.36783 10.5801 7.18975 10.5801 5.7366Z",
    fill: "#2775EB",
    stroke: "#2775EB",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2636 18.945H5.84375V17.8926H14.2636V18.945Z",
    fill: "#2775EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.58 16.2614V9.94629H9.52734V16.2614H10.58Z",
    fill: "#2775EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.68196 16.6344C9.88741 16.8397 10.2208 16.8397 10.4262 16.6344L13.5838 13.4769L12.8395 12.7324L10.0541 15.518L7.26869 12.7324L6.52441 13.4769L9.68196 16.6344Z",
    fill: "#2775EB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadColored);
export default __webpack_public_path__ + "static/media/downloadColored.e8eddfc502ea504b88f99c4ad5ba9c8f.svg";
export { ForwardRef as ReactComponent };